// extracted by css-extract-rspack-plugin
var _1 = "fBizXKae0UiNMBV2";
var _2 = "eefIVZeMrtEQxL5d";
var _3 = "PAaOg3gb5PI8vszy";
var _4 = "yy3ox7yzMbUZnCEv";
var _5 = "KIv9M1To_8wVJ_9y";
var _6 = "qkh67m8jCdknCNsT";
var _7 = "MvXASH91CDoOLgei";
var _8 = "nbUwwFAmISU_pWqV";
var _9 = "Oq6YDvVltOEqS6ct";
var _a = "UTz5_vuMVqctTMZn";
var _b = "B6MbqzMZssImwbv8";
export { _1 as "next", _2 as "pagination", _3 as "paginationItems", _4 as "paginationItemsSizeCompressed", _5 as "paginationItemsSizeLg", _6 as "paginationItemsSizeMd", _7 as "paginationItemsSizeSm", _8 as "paginationSizeLg", _9 as "paginationSizeMd", _a as "paginationSizeSm", _b as "prev" }
// extracted by css-extract-rspack-plugin
var _1 = "fBizXKae0UiNMBV2";
var _2 = "eefIVZeMrtEQxL5d";
var _3 = "PAaOg3gb5PI8vszy";
var _4 = "yy3ox7yzMbUZnCEv";
var _5 = "KIv9M1To_8wVJ_9y";
var _6 = "qkh67m8jCdknCNsT";
var _7 = "MvXASH91CDoOLgei";
var _8 = "nbUwwFAmISU_pWqV";
var _9 = "Oq6YDvVltOEqS6ct";
var _a = "UTz5_vuMVqctTMZn";
var _b = "B6MbqzMZssImwbv8";
export { _1 as "next", _2 as "pagination", _3 as "paginationItems", _4 as "paginationItemsSizeCompressed", _5 as "paginationItemsSizeLg", _6 as "paginationItemsSizeMd", _7 as "paginationItemsSizeSm", _8 as "paginationSizeLg", _9 as "paginationSizeMd", _a as "paginationSizeSm", _b as "prev" }
